import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux'
import { store, checkAuthorizationStatus } from './store/store'
import './css/generic.css';
import App from './App';
import reportWebVitals from './reportWebVitals'

import {ConfigProvider} from 'antd'
import ruLocale from 'antd/es/locale/ru_RU';


checkAuthorizationStatus()

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ConfigProvider locale={ruLocale}>
        <App />
      </ConfigProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
